(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-list"] && !Shopify.designMode) return;
  try {
    (function () {
    document.querySelectorAll('[data-product-list-dual]').forEach((container) => {
      if (container.dataset.productListDualInitialized) return;
      container.dataset.productListDualInitialized = 'true';

      const toggles = container.querySelectorAll('[data-feed-toggle]');
      const feeds = container.querySelectorAll('[data-product-list-feed]');

      toggles.forEach((toggle) => {
        toggle.addEventListener('click', () => {
          const feedId = toggle.dataset.feedToggle;

          toggles.forEach((btn) => {
            btn.setAttribute('aria-selected', btn === toggle ? 'true' : 'false');
          });

          feeds.forEach((feed) => {
            feed.hidden = feed.dataset.productListFeed !== feedId;
          });

          feeds.forEach((feed) => {
            if (feed.dataset.productListFeed === feedId) return;
            if (!feed.hasAttribute('data-slider-block')) return;

            window.getSliderForElement?.(feed)?.destroy();
          });

          feeds.forEach((feed) => {
            if (feed.dataset.productListFeed !== feedId) return;
            if (!feed.hasAttribute('data-slider-block')) return;

            window.getSliderForElement?.(feed)?.checkVisibilityAndInit();
          });
        });
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
